import { useEffect, useState } from 'react';
import { readDevice } from './push';

function Row({ label, value, good }: { label: string; value: string; good?: boolean | undefined }) {
  return (
    <>
      <dt>{label}</dt>
      <dd className={good === undefined ? undefined : good ? 'ok' : 'warn-text'}>{value}</dd>
    </>
  );
}

export function DeviceCheck() {
  const [device] = useState(readDevice);
  const [worker, setWorker] = useState<'checking' | 'active' | 'none'>(
    device.hasServiceWorker ? 'checking' : 'none',
  );

  useEffect(() => {
    if (!device.hasServiceWorker) return;
    let cancelled = false;
    void navigator.serviceWorker.getRegistration().then((reg) => {
      if (!cancelled) setWorker(reg?.active ? 'active' : 'none');
    });
    return () => {
      cancelled = true;
    };
  }, [device.hasServiceWorker]);

  return (
    <section className="card" aria-labelledby="device-title" data-testid="device-check">
      <h2 id="device-title" className="card-heading">
        This device
      </h2>
      <dl className="facts">
        <Row label="Device" value={device.isIos ? 'iPhone / iPad' : 'Not an iPhone'} />
        <Row
          label="Opened as an app"
          value={device.standalone ? 'Yes (from the Home Screen)' : 'No (a browser tab)'}
          good={device.isIos ? device.standalone : undefined}
        />
        <Row
          label="Background worker"
          value={
            worker === 'checking' ? 'Checking…' : worker === 'active' ? 'Running' : 'Not running'
          }
          good={worker === 'checking' ? undefined : worker === 'active'}
        />
        <Row
          label="Notifications supported"
          value={device.hasPush ? 'Yes' : 'No'}
          good={device.hasPush}
        />
        <Row label="Permission" value={device.permission} />
      </dl>
      <details>
        <summary>Browser details (for the report)</summary>
        <p className="hint">{navigator.userAgent}</p>
      </details>
    </section>
  );
}
